import IntersectionObserverAdmin from 'intersection-observer-admin';

export const intersectionObserver = new IntersectionObserverAdmin();
